import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTotalPartner } from '../../redux/slices/totalPartnerSlice';
import {
  MerchantOnboard,
  MerchantApproved,
  MerchantPending,
  MerchantRejected,
} from '../../assets/ImageExports';
import './Status.css';

const StatusCards = () => {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.totalPartner);

  useEffect(() => {
    dispatch(fetchTotalPartner());
  }, [dispatch]);

  const active = data?.totalCount?.total_member_active ?? 0;
  const underProcess = data?.totalCount?.total_member_underprocess ?? 0;
  const pending = data?.totalCount?.total_member_pending ?? 0;
  const rejected = data?.totalCount?.total_member_inactive ?? 0;

  const total = active + underProcess + pending;

  const statusData = [
    {
      title: 'Total Onboard',
      count: total,
      icon: MerchantOnboard,
      color: '#0d6efd',
    },
    {
      title: 'Merchant Onboard',
      count: active,
      icon: MerchantOnboard,
      color: '#0d6efd',
    },
    {
      title: 'Under Process',
      count: underProcess,
      icon: MerchantApproved,
      color: '#198754',
    },
    {
      title: 'Pending',
      count: pending,
      icon: MerchantPending,
      color: '#ffc107',
    },
    {
      title: 'Rejected',
      count: rejected,
      icon: MerchantRejected,
      color: '#dc3545',
    },
  ];

  return (
    <div className="status-grid">
      {loading && <p>Loading...</p>}
      {!loading && !error &&
        statusData.map((item, idx) => (
          <div key={idx} className="status-card">
            <div className="status-icon" style={{ backgroundColor: `${item.color}20` }}>
              <img src={item.icon} alt="icon" style={{ height: 32, width: 32 }} />
            </div>
            <div className="status-info">
              <p className="status-title">{item.title}</p>
              <h3 className="status-count" style={{ color: item.color }}>
                {String(item.count).padStart(2, '0')}
              </h3>
            </div>
          </div>
        ))
      }
    </div>
  );
};

export default StatusCards;
